/**
 * Motion applied to a cropped photo. "drift" is a slow zoom-and-pan (the Ken
 * Burns effect): the still is scaled slightly beyond its frame and moved
 * across it, which reads as a living photograph without any video.
 *
 * Only meaningful where the container crops (object-cover under overflow
 * hidden) — an uncropped image would drift outside its box and shift the page.
 * The animation itself lives in index.css so it can carry keyframes and its
 * own reduced-motion rule.
 */
type ImageMotion = "none" | "drift";

const IMAGE_MOTION_OPTIONS = [
    { label: "None", value: "none" },
    { label: "Slow drift", value: "drift" },
  ] as const,

  /** Class for a drifting image; empty when the photo should sit still. */
  imageMotionClass = (motion: string | undefined): string => {
    if (motion === "drift") {
      return "jobsite-image-drift";
    }
    return "";
  };

export type { ImageMotion };
export { IMAGE_MOTION_OPTIONS, imageMotionClass };
